@if(!modeUpdate){
<div class="legal-info">
  <p>Depuis le 1er janvier 2023, la loi <i>Climat et Résilience</i> rend oblogatoire un Carnet d'Information Logement
    pour toutes les constructions neuves ou les logements rénovés.</p>
  <p>Consultez notre article <a href="https://www.eemo.fr/cil-carnet-dinformation-du-logement/" target="_blank">Tout
      savoir sur le CIL</a> pour plus d'informations.</p>
</div>
}
@if(loading){
<app-data-loading></app-data-loading>
}
@else {
<div class="container-fluid main">
  @if(modeUpdate && currentBooklet){
  <section class="col-12 cil-update">
    <mat-card class="info">
      <mat-card-content>
        <p>CIL <i>{{'enum.PropertyBookletType.'+currentBooklet.type | translate}}</i>
          @if(currentBookletValidated){
          validé le {{ currentBooklet.dateValidation | dateFormat }}
          } @else {
          modifié le {{ currentBooklet.dateUpdate | dateFormat }}
          }
        </p>
        <!--<div><span>Progression :</span>
          <mat-progress-bar mode="determinate" [value]="currentBooklet.progress"></mat-progress-bar>
          <span>{{currentBooklet.progress}}%</span>
        </div>-->
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-content>
        <mat-stepper [orientation]="(stepperOrientation | async)!" #stepper>
          <mat-step *ngIf="isBuilding">
            <ng-template matStepLabel>Construction</ng-template>
            <!-- <app-booklet-resume [prop]="prop" [bookletUid]="currentBooklet.uid"></app-booklet-resume> -->
            <div class="wrap-booklet-card">
              <app-property-booklet-building-card [buildingComponent]="propertyBookletBuildingType.housing"
                [prop]="prop" [bookletUid]="currentBooklet.uid" [bookletInfo]="bookletInfo?.housing"
                (updated)="onUpdatedBuilding()"></app-property-booklet-building-card>
              <app-property-booklet-building-card [buildingComponent]="propertyBookletBuildingType.surface"
                [prop]="prop" [bookletUid]="currentBooklet.uid" [bookletInfo]="bookletInfo?.surface"
                (updated)="onUpdatedBuilding()"></app-property-booklet-building-card>
              <app-property-booklet-building-card [buildingComponent]="propertyBookletBuildingType.waterNetwork"
                [prop]="prop" [bookletUid]="currentBooklet.uid" [bookletInfo]="bookletInfo?.waterNetwork"
                (updated)="onUpdatedBuilding()"></app-property-booklet-building-card>
              <app-property-booklet-building-card [buildingComponent]="propertyBookletBuildingType.electricityNetwork"
                [prop]="prop" [bookletUid]="currentBooklet.uid" [bookletInfo]="bookletInfo?.electricityNetwork"
                (updated)="onUpdatedBuilding()"></app-property-booklet-building-card>
              <app-property-booklet-building-card [buildingComponent]="propertyBookletBuildingType.gasNetwork"
                [prop]="prop" [bookletUid]="currentBooklet.uid" [bookletInfo]="bookletInfo?.gasNetwork"
                (updated)="onUpdatedBuilding()"></app-property-booklet-building-card>
              <app-property-booklet-building-card [buildingComponent]="propertyBookletBuildingType.ventilationNetwork"
                [prop]="prop" [bookletUid]="currentBooklet.uid" [bookletInfo]="bookletInfo?.ventilationNetwork"
                (updated)="onUpdatedBuilding()"></app-property-booklet-building-card>
            </div>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Isolation</ng-template>
            <div class="wrap-booklet-card">
              <app-property-booklet-insulation-card [prop]="prop" [booklet]="currentBooklet"
                [insulation]="currentBookletInsulation?.roof" [type]="propertyBookletInsulationType.roof"
                (updated)="onUpdatedInsulation()"></app-property-booklet-insulation-card>
              <app-property-booklet-insulation-card [prop]="prop" [booklet]="currentBooklet"
                [insulation]="currentBookletInsulation?.walls" [type]="propertyBookletInsulationType.walls"
                (updated)="onUpdatedInsulation()"></app-property-booklet-insulation-card>
              <app-property-booklet-insulation-card [prop]="prop" [booklet]="currentBooklet"
                [insulation]="currentBookletInsulation?.floor" [type]="propertyBookletInsulationType.floor"
                (updated)="onUpdatedInsulation()"></app-property-booklet-insulation-card>
              <app-property-booklet-insulation-card [prop]="prop" [booklet]="currentBooklet"
                [insulation]="currentBookletInsulation?.windows" [type]="propertyBookletInsulationType.windows"
                (updated)="onUpdatedInsulation()"></app-property-booklet-insulation-card>
            </div>
            <div class="controls">
              <button *ngIf="isBuilding" mat-flat-button color="primary" matStepperPrevious>Retour</button>
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Équipements</ng-template>
            <div class="wrap-booklet-card">
              <app-property-booklet-equipment-card [prop]="prop" [booklet]="currentBooklet"
                [equipment]="currentBookletEquipment?.heating" [type]="propertyBookletEquipmentType.heating"
                (updated)="onUpdatedEquipment()"></app-property-booklet-equipment-card>
              <app-property-booklet-equipment-card [prop]="prop" [booklet]="currentBooklet"
                [equipment]="currentBookletEquipment?.cooling" [type]="propertyBookletEquipmentType.cooling"
                (updated)="onUpdatedEquipment()"></app-property-booklet-equipment-card>
              <app-property-booklet-equipment-card [prop]="prop" [booklet]="currentBooklet"
                [equipment]="currentBookletEquipment?.hotWater" [type]="propertyBookletEquipmentType.hotWater"
                (updated)="onUpdatedEquipment()"></app-property-booklet-equipment-card>
              <app-property-booklet-equipment-card [prop]="prop" [booklet]="currentBooklet"
                [equipment]="currentBookletEquipment?.ventilation" [type]="propertyBookletEquipmentType.ventilation"
                (updated)="onUpdatedEquipment()"></app-property-booklet-equipment-card>
              <app-property-booklet-equipment-card [prop]="prop" [booklet]="currentBooklet"
                [equipment]="currentBookletEquipment?.network" [type]="propertyBookletEquipmentType.network"
                (updated)="onUpdatedEquipment()"></app-property-booklet-equipment-card>
              <app-property-booklet-equipment-card *ngIf="!isBuilding" [prop]="prop" [booklet]="currentBooklet"
                [equipment]="currentBookletEquipment?.heatingMaintenance"
                [type]="propertyBookletEquipmentType.heatingMaintenance"
                (updated)="onUpdatedEquipment()"></app-property-booklet-equipment-card>
            </div>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Retour</button>
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Attestations</ng-template>
            <div class="wrap-booklet-card">
              <app-property-booklet-certification-card [prop]="prop" [bookletUid]="currentBooklet.uid"
                [certification]="currentBookletCertification" [type]="PropertyBookletCertificationType.energy"
                (updated)="onUpdatedCertification()"></app-property-booklet-certification-card>
              <app-property-booklet-certification-card [prop]="prop" [bookletUid]="currentBooklet.uid"
                [certification]="currentBookletCertification" [type]="PropertyBookletCertificationType.quality"
                (updated)="onUpdatedCertification()"></app-property-booklet-certification-card>
              <app-property-booklet-certification-card [prop]="prop" [bookletUid]="currentBooklet.uid"
                [certification]="currentBookletCertification" [type]="PropertyBookletCertificationType.re2020"
                (updated)="onUpdatedCertification()"></app-property-booklet-certification-card>
            </div>
            <div class="controls">
              <button mat-flat-button color="primary" matStepperPrevious>Retour</button>
              <button mat-flat-button color="primary" matStepperNext>Suivant</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Validation</ng-template>
            <div class="validate">
              <p>Vous êtes prêt à valider votre CIL.</p>
              <p>Assurez-vous d'avoir bien vérifier ses informations car une fois validé il ne pourra plus être modifié.
              </p>
              <p>La validation générera votre CIL au format PDF, conforme à la loi Climat et Résilience.</p>
              <p *ngIf="!canValidateBooklet" class="alert alert-warning p-2" role="alert">
                Votre bien doit être certifié pour pouvoir valider
                votre CIL. Contactez-le support pour plus d'informations.
              </p>
            </div>
            <div class="controls">
              <button mat-flat-button matStepperPrevious>Retour</button>
              <button mat-flat-button color="primary" (click)="validate()"
                [disabled]="!canValidateBooklet">Valider</button>
            </div>
          </mat-step>
        </mat-stepper>
      </mat-card-content>
    </mat-card>
    <div class="delete">
      <button mat-flat-button class="m-2" color="primary" (click)="closeCurrentBooklet()" [disabled]="deleting">
        <ng-container *ngIf="!deleting; else loading">Fermer</ng-container></button>
    </div>
  </section>
  }
  @else if(modeCreate) {
  <app-property-booklet-create [prop]="prop"
    (bookletCreated)="updateCreatedBooklet($event)"></app-property-booklet-create>
  }
  @else {
  <div class="wrap-resume">
    <app-property-booklet-card *ngFor="let booklet of bookletList" class="col-12 cold-md-6 col-xl-4" [prop]="prop"
      [booklet]="booklet" (updateBookletClicked)="updateCreatedBooklet($event.uid)"
      (deleteBookletClicked)="confirmDeleteBooklet($event)"></app-property-booklet-card>
  </div>
  <div *ngIf="canUpdateProperty && !hasInProgress" class="text-end">
    <button mat-flat-button color="primary" (click)="addBooklet()">Ajouter un nouveau CIL</button>
  </div>
  }
  <ng-template #loading>
    <mat-icon>
      <mat-spinner diameter="20">
      </mat-spinner>
    </mat-icon>
  </ng-template>
</div>
}